<template>
  <div
    tabindex="0"
    class="px-4 py-6 transition duration-300 rounded-lg cursor-pointer focus:outline-none"
    :class="isOpen ? currentTheme.colorBackgroundActive : currentTheme.colorBackground"
    @click="toggle"
  >
    <!--Question-->
    <dt>
      <div
        class="flex items-start justify-between w-full h-full text-left rounded-md"
        :class="currentTheme.colorText"
      >
        <span class="text-sm font-bold lg:text-lg sm:text-base">
          {{ label }}
        </span>
        <span class="flex items-center ml-6 h-7">
          <svg
            class="w-6 h-6 transform"
            :class="[isOpen ? '-rotate-180' : 'rotate-0']"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </span>
      </div>
    </dt>

    <!--Content-->
    <dd
      v-show="isOpen"
      class="pt-5"
    >
      <div
        class="text-sm leading-6 sm:text-base"
        :class="currentTheme.colorText"
        v-html="answer"
      />
    </dd>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  theme: {
    type: String,
    default: 'dark',
    validator: (value) => ['light', 'dark'].includes(value)
  },
  label: {
    type: String,
    required: true
  },
  answer: {
    type: String,
    required: true
  }
});

const isOpen = ref(false);

const themes = [
  { name: 'light', colorBackground: 'bg-tertiary hover:bg-tertiary-light', colorBackgroundActive: 'bg-tertiary bg-tertiary-light', colorText: 'text-dark-800' },
  { name: 'dark', colorBackground: 'bg-dark-900 hover:bg-opacity-80', colorBackgroundActive: 'bg-dark-900 bg-opacity-80', colorText: 'text-light' },
];

const currentTheme = computed(() => themes.find(t => t.name === props.theme));

const toggle = () => {
  isOpen.value = !isOpen.value;
}

</script>
